import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-confirmation-dialog',
	templateUrl: './confirmation-dialog.component.html',
	styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
	) {}

	ngOnInit(): void {}

	ok() {
		this.dialogRef.close({
			response: true,
		});
	}
	close() {
		this.dialogRef.close({
			response: false,
		});
	}
	cancel() {
		this.dialogRef.close({
			response: null,
		});
	}
}

interface ConfirmDialogData {
	title: string;
	message: string;
	okText: string;
	cancelText: string;
}
